import { cloneElement } from "react";
import { ART_SLOTS } from "./slots";

/** Renders painted art for `slot` when one is configured, otherwise the code-drawn fallback. */
const ArtLayer = ({ slot, className = "", children }) => {
  const src = ART_SLOTS[slot];
  if (src) {
    return <img className={`rm-art-img ${className}`} src={src} alt="" aria-hidden="true" draggable="false" />;
  }
  return cloneElement(children, {
    className: `${children.props.className || ""} ${className}`.trim(),
  });
};

export default ArtLayer;
